import React from "react";
import SVGattendence from "../../../assets/Images/SVGattendence.svg";
import SVGChat from "../../../assets/Images/SVGChat.svg";
import SVGClass from "../../../assets/Images/SVGClass.svg";
import SVGDatabase from "../../../assets/Images/SVGDatabase.svg";
import SVGFees from "../../../assets/Images/SVGFees.svg";
import SVGOnlineTest from "../../../assets/Images/SVGOnlineTest.svg";
import SVGPrivacy from "../../../assets/Images/SVGPrivacy.svg";
import SVGReports from "../../../assets/Images/SVGReports.svg";

const FeaturesList = () => {
  return (
    <div className="featuresList">
      <div className="featuresList_content">
        <img
          src={SVGattendence}
          alt="circled"
          className="featuresList_content_img"
        />
        <p className="featuresList_content_head">Smart Attendance</p>
        <p className="featuresList_content_text">
          Keep parents updated with live attendance and monthly reports.
        </p>
      </div>

      <div className="featuresList_content">
        <img
          src={SVGReports}
          alt="circled"
          className="featuresList_content_img"
        />
        <p className="featuresList_content_head">Insighful Student Reports</p>
        <p className="featuresList_content_text">
          Personalised performance reports <br /> for all your students
        </p>
      </div>

      <div className="featuresList_content">
        <img src={SVGChat} alt="circled" className="featuresList_content_img" />
        <p className="featuresList_content_head">Parent Communication Module</p>
        <p className="featuresList_content_text">
          Chat with parents, anytime, anywhere. Disable chat when you're busy
        </p>
      </div>

      <div className="featuresList_content">
        <img src={SVGFees} alt="circled" className="featuresList_content_img" />
        <p className="featuresList_content_head">Fee Records</p>
        <p className="featuresList_content_text">
          Automatic reminders and receipts for instalments of students' due fees
        </p>
      </div>

      <div className="featuresList_content">
        <img
          src={SVGPrivacy}
          alt="circled"
          className="featuresList_content_img"
        />
        <p className="featuresList_content_head">Privacy Control</p>
        <p className="featuresList_content_text">
          Control what info your faculties and admin can view for your batches
        </p>
      </div>

      <div className="featuresList_content">
        <img
          src={SVGOnlineTest}
          alt="circled"
          className="featuresList_content_img"
        />
        <p className="featuresList_content_head">Online Test</p>
        <p className="featuresList_content_text">
          Conduct your online tests powered with automatic checking and
          solutions.
        </p>
      </div>

      <div className="featuresList_content">
        <img
          src={SVGDatabase}
          alt="circled"
          className="featuresList_content_img"
        />
        <p className="featuresList_content_head">Data Security</p>
        <p className="featuresList_content_text">
          Your data is secured using SSL AES 256-bit encryption
        </p>
      </div>

      <div className="featuresList_content">
        <img
          src={SVGClass}
          alt="circled"
          className="featuresList_content_img"
        />
        <p className="featuresList_content_head">Class Management</p>
        <p className="featuresList_content_text">
          Forget tons of paperwork and manage your institute completely
          digitally
        </p>
      </div>
    </div>
  );
};

export default FeaturesList;
